import { createAuthClient } from "better-auth/react";
import { usernameClient } from "better-auth/client/plugins";

const rawURL = (
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_URL_DEV
    : process.env.REACT_APP_URL_PROD
) ?? "";

let betterAuthBaseURL = rawURL.replace(/\/$/, "");
let betterAuthBasePath: string | undefined;

try {
  const u = new URL(rawURL);
  const proxyPrefix = u.pathname.replace(/\/+$/, ""); // "" or "/api"
  betterAuthBaseURL = u.origin;
  if (proxyPrefix) betterAuthBasePath = `${proxyPrefix}/auth`;
} catch {
  // keep rawURL as-is
}

export const authClient = createAuthClient({
  baseURL: betterAuthBaseURL,
  basePath: betterAuthBasePath ?? '/auth',
  plugins: [usernameClient()],
});
